import {METHOD} from "services/method";

export const API_MASTER = {
    PAYMENT_METHOD: {
        api: '/v1/master/payment-methods',
        method: METHOD.GET,
    },
    SHIPPING_METHOD: {
        api: '/v1/master/shipping-methods',
        method: METHOD.GET,
    },
}
